import { render, staticRenderFns } from "./Sea.vue?vue&type=template&id=3a8792c4&scoped=true&"
import script from "./Sea.vue?vue&type=script&lang=js&"
export * from "./Sea.vue?vue&type=script&lang=js&"
import style0 from "./Sea.vue?vue&type=style&index=0&id=3a8792c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8792c4",
  null
  
)

export default component.exports